import { MetaData } from '../services/meta.service';

interface MetaDataMapping {
	[key: string]: MetaData;
}

export const metaData: MetaDataMapping = {
	dashboard: {
		title: 'pagetitles.dashboard'
	},
	managerDashboard: {
		title: 'lup.manager_dashboard.label'
	},
	dynamicRules: {
		title: 'groups.navigation_actions.dynamic_rules'
	},
	chatIntegration: {
		title: 'lup.subnav.lup_chat_integrations_settings'
	},
	users: {
		title: 'lup.subnav.users'
	},
	courses: {
		title: 'lup.tips.courses'
	},
	courseEnrolments: {
		title: 'lup.tips.courses'
	}
};
